import React from "react";
import { TfiClose } from "react-icons/tfi";

const Model = ({ closeModal, title, children, isForm, loading,handleSubmit }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div 
        className="absolute inset-0 bg-transparent z-40"
        onClick={closeModal} 
      />
      <div className="modal-content bg-white rounded-lg p-6 w-full mx-4 max-w-2xl md:max-h-[90vh] max-h-[80vh] overflow-y-auto custom-scrollbar relative z-50">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold mb-0">{title}</h2>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-800"
          >
            <TfiClose />
          </button>
        </div>
        <hr className="my-3" />
        {isForm === true ? (
          <form onSubmit={handleSubmit}>
            {children}
            <div className="flex items-center justify-center mt-5 gap-5">
              <button
                type="button"
                className="w-[150px] h-[50px] flex justify-center items-center border border-[#124699] rounded-md text-[#124699]"
                onClick={closeModal}
              >
                <p className="font-semibold">Cancel</p>
              </button>
              <button
                type="submit"
                className="w-[150px] h-[50px] flex justify-center items-center text-white bg-[#124699] rounded-md hover:bg-[#124699]"
              >
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        ) : (
          <>
            {children}
            <div className="mt-6 flex justify-center">
              <button
                onClick={closeModal}
                className="px-10 py-2 bg-[#124699] text-white rounded-lg hover:bg-[#124699]"
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Model;
